import {
    CREATE_STITCHING_INWARD_DETAILS_FAILURE,
    CREATE_STITCHING_INWARD_DETAILS_REQUEST,
    CREATE_STITCHING_INWARD_DETAILS_SUCCESS,
    CREATE_USER_FORM_STITCHING_INWARD_DETAILS,
    DELETE_STITCHING_INWARD_DETAILS_FAILURE,
    DELETE_STITCHING_INWARD_DETAILS_REQUEST,
    DELETE_STITCHING_INWARD_DETAILS_SUCCESS,
    FETCH_SINGLE_STITCHING_INWARD_DETAILS_FAILURE,
    FETCH_SINGLE_STITCHING_INWARD_DETAILS_REQUEST,
    FETCH_SINGLE_STITCHING_INWARD_DETAILS_SUCCESS,
    FETCH_STITCHING_INWARD_DETAILS_FAILURE,
    FETCH_STITCHING_INWARD_DETAILS_REQUEST,
    FETCH_STITCHING_INWARD_DETAILS_SUCCESS,
    STITCHING_INWARD_DETAILS_USERFORM_RESET,
    UPDATE_STITCHING_INWARD_DETAILS_FAILURE,
    UPDATE_STITCHING_INWARD_DETAILS_REQUEST,
    UPDATE_STITCHING_INWARD_DETAILS_SUCCESS,
    FETCH_STITCHING_INWARD_DETAILS_BY_ID_REQUEST,
    FETCH_STITCHING_INWARD_DETAILS_BY_ID_SUCCESS,
    STITCHING_INWARD_DETAILS_PO_DETAILS_DISABLED,
    FETCH_STITCHING_INWARD_DETAILS_EDIT_QTY_SUCCESS,
    FETCH_STITCHING_INWARD_DETAILS_EDIT_QTY_REQUEST,
    FETCH_STITCHING_INWARD_DETAILS_EDIT_QTY_FAILURE,
    RESET_EDIT_QUANTITY_GRID_DATA_WITHOUT_STITCHING_INWARD_ID,
    SET_EDIT_QUANTITY_GRID_DATA_WITHOUT_STITCHING_INWARD_ID,
    FETCH_DETAIL_DC_NO_SUCCESS,
    FETCH_CUT_PANEL_GET_SUCCESS,
    FETCH_CUT_PANEL_GET_FALIURE,
    FETCH_CUT_PANEL_GET_REQUEST
} from './stitchingInwardDetails.actionsType';

export const STITCHING_INWARD_DETAILS = 'stitchingInwardDetails';

let initialState = {
    loading: false,
    stitchingInwardDetailsById: [],
    stitchingInwardDetails: [],
    editGridData: [],
    stitchingInwardDetailsForm: {
        fldGrossValue: 0,
        fldDiscountValue: 0,
        fldIGSTValue: 0,
        fldSGSTValue: 0,
        fldCGSTValue: 0,
        fldCGSTPercentage: 0,
        fldIGSTPercentage: 0,
        fldSGSTPercentage: 0,
        fldDiscountPercentage: 0
    },
    selectedStitchingDetails: {},
    isPoDetailsDisabled: false,
    errorMessage: '',
    iperrorMessage: ''
};


export let stitchingInwardDetailsReducer = (state = initialState, action) => {
    let { type, payload, updatePayload } = action;
    switch (type) {
        case FETCH_STITCHING_INWARD_DETAILS_REQUEST:
        case FETCH_STITCHING_INWARD_DETAILS_BY_ID_REQUEST:
        case FETCH_STITCHING_INWARD_DETAILS_EDIT_QTY_REQUEST:
        case CREATE_STITCHING_INWARD_DETAILS_REQUEST:
        case FETCH_SINGLE_STITCHING_INWARD_DETAILS_REQUEST:
        case UPDATE_STITCHING_INWARD_DETAILS_REQUEST:
        case DELETE_STITCHING_INWARD_DETAILS_REQUEST:
        case FETCH_CUT_PANEL_GET_REQUEST:
            return {
                ...state,
                loading: true
            };
        case FETCH_STITCHING_INWARD_DETAILS_SUCCESS:
            return {
                ...state,
                loading: false,
                stitchingInwardDetails: updatePayload
            };
        case FETCH_DETAIL_DC_NO_SUCCESS: {
            return {
                ...state,
                loading: false,
                dcNoForDetail: updatePayload
            }
        }
        case FETCH_STITCHING_INWARD_DETAILS_BY_ID_SUCCESS:
            return {
                ...state,
                loading: false,
                stitchingInwardDetailsById: updatePayload
            };
        case FETCH_STITCHING_INWARD_DETAILS_EDIT_QTY_SUCCESS:
            // const updatePayload = action.payload; // Assuming action.payload contains the updatePayload
            const numericPending = updatePayload?.CUD?.map(obj => obj.FldQuantity)
                .filter(pending => typeof pending === 'number');
            let lowestPending = Math.min(...numericPending);


            // we need to something diffrent data is an requirement thats why changed here
            return {
                ...state,
                loading: false,
                sortedRows: numericPending,
                searchData: updatePayload?.CUD?.filter((x) => x.DisPlay === 0)?.map((y) => ({ ...y, Bal: y.PendingQty - y.ReceivedQty })),
                editGridData: updatePayload?.CUD?.filter((x) => x.DisPlay === 0)?.map((y) => ({ ...y, Bal: y.PendingQty - y.ReceivedQty })),
                allDataLists: updatePayload?.CUD || [],
                unMatchedRows: updatePayload?.CUD[0]?.DisPlayresult === 1 ? updatePayload?.CUD : updatePayload?.CUD?.filter((x) => Number(x.FldQuantity) !== Number(lowestPending)),
                cutPanel: updatePayload?.CUD?.map((x) => ({ ...x, totalQty: x.PendingQty - x.ReceivedQty, }))
            };

        case CREATE_STITCHING_INWARD_DETAILS_SUCCESS:
            return {
                ...state,
                loading: false,
                stitchingInwardDetailsForm: {
                    fldGrossValue: 0,
                    fldDiscountValue: 0,
                    fldIGSTValue: 0,
                    fldSGSTValue: 0,
                    fldCGSTValue: 0,
                    fldCGSTPercentage: 0,
                    fldIGSTPercentage: 0,
                    fldSGSTPercentage: 0,
                    fldDiscountPercentage: 0
                },
                isPoDetailsDisabled: false
            };
        case RESET_EDIT_QUANTITY_GRID_DATA_WITHOUT_STITCHING_INWARD_ID:
            return {
                ...state,
                loading: false,
                editGridData: []
            };
        case FETCH_SINGLE_STITCHING_INWARD_DETAILS_SUCCESS:
            return {
                ...state,
                loading: false,
                selectedStitchingDetails: updatePayload,
                stitchingInwardDetailsForm: { ...updatePayload }
            };
        case UPDATE_STITCHING_INWARD_DETAILS_SUCCESS:
            return {
                ...state,
                loading: false,
                selectedStitchingDetails: {},
                stitchingInwardDetailsForm: {
                    fldGrossValue: 0,
                    fldDiscountValue: 0,
                    fldIGSTValue: 0,
                    fldSGSTValue: 0,
                    fldCGSTValue: 0,
                    fldCGSTPercentage: 0,
                    fldIGSTPercentage: 0,
                    fldSGSTPercentage: 0,
                    fldDiscountPercentage: 0
                },
                isPoDetailsDisabled: false
            };
        case DELETE_STITCHING_INWARD_DETAILS_SUCCESS:
            return {
                ...state,
                loading: false,
                stitchingInwardDetailsForm: {
                    fldGrossValue: 0,
                    fldDiscountValue: 0,
                    fldIGSTValue: 0,
                    fldSGSTValue: 0,
                    fldCGSTValue: 0,
                    fldCGSTPercentage: 0,
                    fldIGSTPercentage: 0,
                    fldSGSTPercentage: 0,
                    fldDiscountPercentage: 0
                },
                selectedStitchingDetails: {},
                isPoDetailsDisabled: false
            };

        case FETCH_STITCHING_INWARD_DETAILS_FAILURE:
        case FETCH_STITCHING_INWARD_DETAILS_EDIT_QTY_FAILURE:
        case FETCH_SINGLE_STITCHING_INWARD_DETAILS_FAILURE:
        case CREATE_STITCHING_INWARD_DETAILS_FAILURE:
        case UPDATE_STITCHING_INWARD_DETAILS_FAILURE:
        case DELETE_STITCHING_INWARD_DETAILS_FAILURE:
        case FETCH_CUT_PANEL_GET_FALIURE:
            return {
                ...state,
                loading: false,
                errorMessage: updatePayload
            };

        case FETCH_CUT_PANEL_GET_SUCCESS:
            return {
                ...state,
                loading: false,
                cutPanelLists: updatePayload
            }
        case CREATE_USER_FORM_STITCHING_INWARD_DETAILS:
            return {
                ...state,
                loading: false,
                stitchingInwardDetailsForm: {
                    ...state.stitchingInwardDetailsForm,
                    [payload.key]: payload.value
                }
            };
        case SET_EDIT_QUANTITY_GRID_DATA_WITHOUT_STITCHING_INWARD_ID:
            return {
                ...state,
                loading: false,
                editGridData: payload
            };
        case STITCHING_INWARD_DETAILS_PO_DETAILS_DISABLED:
            return {
                ...state,
                isPoDetailsDisabled: payload
            };
        case STITCHING_INWARD_DETAILS_USERFORM_RESET:
            return {
                ...state,
                stitchingInwardDetailsForm: {
                    fldGrossValue: 0,
                    fldDiscountValue: 0,
                    fldIGSTValue: 0,
                    fldSGSTValue: 0,
                    fldCGSTValue: 0,
                    fldCGSTPercentage: 0,
                    fldIGSTPercentage: 0,
                    fldSGSTPercentage: 0,
                    fldDiscountPercentage: 0
                },
                selectedStitchingDetails: {},
                isPoDetailsDisabled: false
            };
        default:
            return state;
    }
};
